<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div class="flex gap-2 bg-white items-center">
      <img src="../../assets/image/search.svg" alt="" class="" />
      <input
        placeholder="Search Partner Name Here..."
        (keyup)="onKeyUp($event, pagination)"
        class="w-full border p-2 rounded-md outline-none"
      />
      <!-- <select class="w-80 border p-2 rounded-xl outline-none" (change)="getAllProviderViaFilter($event)">
          <option value="">Select Filter</option>
          <option value="PayIn">Pay In</option>
          <option value="PayOut">Pay Out</option>
        
          <option value="PayIn/PayOut">PayIn/PayOut</option>
        </select> -->

      <!-- <div class="flex-none">
          <app-primary-button (click)="openToCreate()">
            <div class="flex gap-2">
              <img src="../../../../assets/image/+.svg" alt="" />
              Add Provider
            </div></app-primary-button
          >
        </div> -->
    </div>
  </div>
  <div class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-auto">
    <table
      class="w-[100%] text-left h-full overflow-y-auto"
      *ngIf="customerCompanyData.length > 0"
    >
      <tr class="h-8 p-3">
        <th class="p-2 px-4 text-nowrap">Sr No.</th>
        <!-- <th class="p-2">User ID</th> -->
        <th class="p-2 px-4 text-nowrap">Partner Name</th>
        <th class="p-2 px-4 text-nowrap">Industry Type</th>
        <th class="p-2 px-4 text-nowrap">Mobile</th>
        <th class="p-2 px-4 text-nowrap">Email</th>
        <!-- <th class="p-2">Logo</th> -->
        <!-- <th class="p-2">Action</th> -->
        <th class="p-2" *ngIf="permissions.includes('partner-profile-edit')">
          Edit
        </th>
      </tr>
      <tr
        class="p-3"
        *ngFor="let items of customerCompanyData; let i = index"
        [ngStyle]="{
          backgroundColor:
            i % 2 == 0
              ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
              : 'white'
        }"
      >
        <td class="px-4 p-3">
          {{ i + 1 + (pagination.currentPage - 1) * 10 }}
        </td>
        <!-- <td class="">
            <div>{{ items._id }}</div>
          </td> -->
        <td class="px-4">
          <div class="cursor-pointer" (click)="toggleView(items._id)">{{ items.businessName | titlecase }}</div>
        </td>
        <td class="px-4">
          <div>{{ items.industryType.title | titlecase }}</div>
        </td>
        <td class="px-4">
          {{ items.phone }}
        </td>
        <td class="px-4">
          <div>{{ items.email }}</div>
        </td>
        <!-- <td class="p-2">
          <img src="../../assets/image/logo.png" alt="" class="w-24" />
        </td> -->
        <td
          class="p-2"
          (click)="routeToEditPortalBuilder(items)"
          *ngIf="permissions.includes('partner-profile-edit')"
        >
          <img src="../../assets/image/edit.svg" alt="" class="w-25" />
        </td>
        <!-- <td class="p-2">
            <div class="bg-[#b52525] px-3 rounded-full text-white text-center">
              {{ items.action ? items.action :"Action" }}
            </div>

          </td> -->
      </tr>
    </table>
  </div>
  <app-next-preview-button
    [limit]="pagination.limit"
    [currentPage]="pagination.currentPage"
    [totalPage]="totalPage"
    [totalRecords]="totalRecords"
    (next)="nextPage()"
    (previous)="previousPage()"
    (pageChange)="onPageChange($event)"
    (last)="onLast()"
    (first)="onFirst()"
  ></app-next-preview-button>
  <app-empty-data
    *ngIf="customerCompanyData.length < 1"
    class="justify-center align-items-center"
    [imageSource]="'../../assets/blankScreen/9.png'"
    [message]="'No data availables'"
  ></app-empty-data>
</div>

<!-- bg-[#f2e9f8] -->
